<p-tabView [(activeIndex)]="index" (onChange)="getIndex($event)">
  <p-tabPanel header="Location">
    <p-table [value]="allLocations">
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>Type</th>
          <th>Group</th>
          <th style="width: 200px;">Category</th>
          <th>Is Default</th>
          <th>Is Active</th>
          <th>Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-location let-i="rowIndex">
        <tr>
          <td>{{location.name}}</td>
          <td>{{location.type?location.type.name:''}}</td>
          <td>{{location.group?location.group.name:''}}</td>
          <td>
            <ng-container *ngFor="let s of location.warehouseCategory; last as isLast">
              <span>{{s.category?s.category.name:''}}</span>
              <ng-container *ngIf="!isLast">,</ng-container>
            </ng-container>
          </td>
          <td class="action">
            <p-radioButton [disabled]="location.statusId==statusConstants.INACTIVE" [value]="true"
              [(ngModel)]="location.isDefault" (onClick)="locationDefault(location)"></p-radioButton>
            {{location.isDefault?answertypeConstants.Yes: answertypeConstants.No}}
          </td>
          <td>{{location.statusId==statusConstants.ACTIVE?answertypeConstants.Yes: answertypeConstants.No}}</td>
          <td class="action">
            <span class="btnBars p-mr-0" (click)="showEditLocation(location)" pTooltip="Edit" tooltipPosition="top"><i
                class="pi pi-pencil"></i></span>
            <span class="btnBars p-mr-0" *ngIf="!location.isDefault" (click)="checkDeleteWarehouse(location)"
              pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-tabPanel>
  <p-tabPanel header="Bin" *ngIf="inventoryGroups.length>0">
    <app-bins [groups]="inventoryGroups"></app-bins>
  </p-tabPanel>
  <p-tabPanel header="Fields" *ngIf="category.length>0 && categoryGroup">
    <app-location-fields [categories]="category" [categoryGroup]="categoryGroup"></app-location-fields>
  </p-tabPanel>
  <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
    <ng-template pTemplate="header">
      <p-menu #configmenuLocation id="config_menu_location" [model]="configMenuLocationItems" [popup]="true"
        appendTo="body">
      </p-menu>
      <span class="btnBars p-mr-0" (click)="configmenuLocation.toggle($event)">
        <i class="pi pi-bars"></i>
      </span>
    </ng-template>
  </p-tabPanel>
</p-tabView>

<p-dialog header="{{locationHeader}}" [(visible)]="displayAddEditLocation" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <app-subscription-limit-message *ngIf="subscriptionLimitReached" [subscriptionLimit]="subscriptionLimit"
    [moduleName]="'Location'">
  </app-subscription-limit-message>

  <form *ngIf="!subscriptionLimitReached" [formGroup]="locationForm">
    <div class="header">
      <h5>Location Information
        <p-inputSwitch class="header-switch" formControlName="statusId" [disabled]="statusDisabled"
          (onChange)="checkWarehouseStatus()"></p-inputSwitch>
      </h5>
    </div>
    <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-6">
          <label for="name">Location ID<span style="color: red;">*</span></label>
          <input type="text" pInputText formControlName="locationId" (focusout)="checkDuplicateLocationId()">
          <small *ngIf="duplicateItem" class="p-invalid">
            LocationID already exists.
          </small>
        </div>
        <div class="p-col-6">
          <label for="name">Name<span style="color: red;">*</span></label>
          <input type="text" pInputText formControlName="name">
          <small *ngIf="invalidData == true" class="p-invalid">
            Name already exists.
          </small>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-4">
          <label>Type</label>
          <p-dropdown appendTo="body" [options]="types" optionLabel="name" [ngModelOptions]="{standalone: true}"
            formControlName="typeId"></p-dropdown>
        </div>
        <div class="p-col-4">
          <label>Group</label>
          <p-dropdown appendTo="body" [options]="groups" optionLabel="name" [ngModelOptions]="{standalone: true}"
            formControlName="groupId" (onChange)="addNewOption(locationForm.value)"></p-dropdown>
        </div>
        <div class="p-col-4">
          <label>Category</label>
          <p-multiSelect appendTo="body" [options]="category" optionLabel="name" [ngModelOptions]="{standalone: true}"
            formControlName="warehouseCategory" placeholder="Select Category">
          </p-multiSelect>
        </div>
      </div>
    </div>
    <div class="header">
      <h5>Address Information</h5>
    </div>
    <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6">
          <label>Street Address 1 <span style="color: red;">*</span></label>
          <lion-gm-place-autocomplete [formattedAddress]="addressInput" (onRemoveAddress)="removeAddressLocation()"
            (onAddressChange)="locationAddresChanged($event)">
          </lion-gm-place-autocomplete>
          <small class="p-invalid">{{ ErrorMessageSetLocation }}</small>
        </div>
        <div class="p-col-12 p-lg-6">
          <label>Street Address 2</label>
          <input pInputText type="text" [(ngModel)]="streetAddress2" [ngModelOptions]="{ standalone: true }">
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6">
          <label>Country <span style="color: red;">*</span></label>
          <p-dropdown appendTo="body" [ngModelOptions]="{ standalone: true }" [options]="country" optionLabel="name"
            [(ngModel)]="selectedCountry" placeholder="Select Country" [filter]="true"
            (onChange)="getStatesFromCountry($event.value)">
          </p-dropdown>
        </div>
        <div class="p-col-12 p-lg-6">
          <label>State <span style="color: red;">*</span></label>
          <p-dropdown appendTo="body" [ngModelOptions]="{ standalone: true }" [options]="states"
            placeholder="Select State" [(ngModel)]="selectedState" [filter]="true" optionLabel="name"
            (onChange)="getCitiesFromState($event.value)">
          </p-dropdown>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6">
          <label>City <span style="color: red;">*</span></label>
          <p-dropdown appendTo="body" [ngModelOptions]="{ standalone: true }" [options]="city" placeholder="Select City"
            [(ngModel)]="selectedCity" [filter]="true" optionLabel="name"></p-dropdown>
        </div>
        <div class="p-col-12 p-lg-3">   
          <label>Zipcode</label>
          <input pInputText type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="zipCode">
        </div>
        <div class="p-col-12 p-lg-3">
          <label>Contact Person</label>
          <p-autoComplete formControlName="userId" [suggestions]="allContactsDD"
            (completeMethod)="filterContact($event)" field="fullName" [minLength]="1" placeholder="Search contact"
            (onClear)="clearContact($event)">
          </p-autoComplete>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-md-6">
          <label>Location Email<span style="color: red;">*</span></label>
          <input pInputText type="text" formControlName="emailId">
        </div>
        <div class="p-col-12 p-md-6">
          <label>Location Phone<span style="color: red;">*</span></label>
          <input pInputText type="text" formControlName="phoneNo">
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" pButton (click)="displayAddEditLocation=false" label="Cancel"
      class="p-button-secondary"></button>
    <button type="button" pButton label="Save" [disabled]="!locationForm.valid || duplicateItem || !addressMandatory"
      (click)="saveLocation(locationForm.value)"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Delete Location" [(visible)]="displayLocationAvailability" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <div class="header">
    <h5>Delete Warning</h5>
  </div>
  <div class="card">
    <span>{{associatedProducts}}</span>
  </div>
</p-dialog>

<p-dialog header="{{addEditOptionHeader}}" [modal]="true" [(visible)]="displayAddNewOption" [style]="{width: '50vw'}"
  [baseZIndex]="10000" (onHide)="addNewOptionForm.reset()">
  <form [formGroup]="addNewOptionForm">
    <div class="p-grid">
      <div class="p-col-6">
        <label for="name">Group Name <span style="color: red;">*</span></label>
        <input type="text" pInputText formControlName="name">
        <small *ngIf="invalidGroupData" class="p-invalid">Name already exists.</small>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button pButton (click)="displayAddNewOption=false" label="Cancel" class="p-button-secondary"></button>
    <button pButton [disabled]="!addNewOptionForm.valid" (click)="saveGroup(addNewOptionForm.value)"
      label="Save"></button>
  </ng-template>
</p-dialog>